
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[slug]/[params]",
      function () {
        return require("private-next-pages/products/[slug]/[params].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[slug]/[params]"])
      });
    }
  